import { render } from "./Pay.vue?vue&type=template&id=bd25efe0&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=bd25efe0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bd25efe0"

export default script